(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["landing-audifonos-pro3"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-nd-pp-offer]').forEach(function (offer) {
    if (offer.dataset.ndPpBound === 'true') return;
    offer.dataset.ndPpBound = 'true';
    offer.addEventListener('change', function () {
      var form = offer.closest('form');
      var variantInput = form && form.querySelector('[data-nd-pp-variant-id]');
      if (!variantInput || !offer.checked) return;
      variantInput.value = offer.value;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      variantInput.dispatchEvent(new Event('input', { bubbles: true }));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
